import { getAsyncData } from "../utils/storeAndRetrieveUtil";

import { get, create, update, deleteResource } from "./apiService";
import CurrencyFormatter from "./currencyFormatterService";
import { getAllTradingAssets, getAssetPairs } from "./tradingDataService";

const pendingRequests = new Map();

export const initDigitalWallet = async () => {
  try {
    const result = await create("api/v1/trading-wallet/dashboard");

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const withdraw = async (data) => {
  try {
    const result = await create("api/v1/fiat/user-withdrawal/create", data);

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const withdrawQuote = async (data) => {
  try {
    const result = await create("api/v1/fiat/withdrawal-quote", data);

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const getEightyEightBank = async () => {
  try {
    const result = await get("api/v1/trading-asset-bank/view");

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};

export const getTradingAssets = async () => {
  try {
    const result = await get("api/v1/trading-wallet/get-assets");

    return result;
  } catch (err) {
    throw new Error(`Could get trading assets data: ${err.message}`);
  }
};
export const getResendEmail = async () => {
  try {
    const result = await get("api/v1/user/verify-email");
    return result;
  } catch (err) {
    throw new Error(`Could not get resend email: ${err.message}`);
  }
};
export const getWalletAddresses = async () => {
  try {
    const result = await get("api/v1/address-book/user-addresses");
    return result;
  } catch (err) {
    throw new Error(`Could not get wallet addresses: ${err.message}`);
  }
};
export const getPairs = async (assetId) => {
  try {
    const pairs = await getAssetPairs(assetId);

    return {
      data: {
        data: pairs,
        status: true,
        message: "Fetched pairs successfully",
      },
    };
  } catch (err) {
    throw new Error(`Could not get pairs: ${err.message}`);
  }
};

export const getUserBalances = async () => {
  try {
    const authId = await getAsyncData("authId");

    if (authId == null) {
      throw new Error("Could not get user id.");
    }

    const result = get("/api/v1/get-balances", { userId: authId });

    if (result) {
      return result;
    }

    return null;
  } catch (err) {
    throw new Error(`Could not get balances. Error: ${err.message}`);
  }
};

export const getWalletBalance = async (assetId) => {
  try {
    const result = await get(
      `api/v1/trading-wallet/wallet-balance?assetId=${assetId}`
    );

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};

export const getWalletBalances = async () => {
  try {
    return await getPortfolioEstimateAssets();
  } catch (err) {
    throw new Error(`Could not get wallet balances: ${err.message}`);
  }
};
export const getPortfolio = async (data) => {
  try {
    const result = await get(
      `api/v1/trading-wallet/portfolio-estimate/${data.userId}/${data.asset}`
    );

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const getSecret = async () => {
  try {
    const result = await get("api/v1/auth/get-secret");

    return result;
  } catch (err) {
    throw new Error(`Could not get 2FA secret: ${err.message}`);
  }
};
export const enable2FA = async (data) => {
  try {
    const result = await create("api/v1/settings/enable-twofa", data);

    return result;
  } catch (err) {
    throw new Error(`Failed to enable 2FA: ${err.message}`);
  }
};
export const verify2FA = async (data) => {
  try {
    const result = await create("api/v1/auth/verify-code", data);

    return result;
  } catch (err) {
    throw new Error(`2FA verification failed: ${err.message}`);
  }
};
export const createWalletAddress = async (data) => {
  try {
    const result = await create("api/v1/address-book/create", data);

    return result;
  } catch (err) {
    throw new Error(`Something went wrong: ${err.message}`);
  }
};

export const createBankAccount = async (data) => {
  try {
    const result = await create("api/v1/user-banking/create", data);

    return result;
  } catch (err) {
    throw new Error(`Something went wrong: ${err.message}`);
  }
};

export const createSendQuote = async (data) => {
  try {
    const result = await create("api/v1/crypto-transactions/get-quote", data);

    return result;
  } catch (err) {
    throw new Error(`Something went wrong: ${err.message}`);
  }
};
export const getUserBanking = async (userId) => {
  try {
    const result = await get(`api/v1/user-banking/get-banking/${userId}`);

    return result;
  } catch (err) {
    throw new Error(`Something went wrong: ${err.message}`);
  }
};
export const getUserBank = async (bankId) => {
  try {
    const result = await get(
      `api/v1/user-banking/get-bank?bankAccId=${bankId}`
    );

    return result;
  } catch (err) {
    throw new Error(`Something went wrong: ${err.message}`);
  }
};

export const getUserOrders = async (userId) => {
  try {
    const result = await get(`api/v1/orders/user-orders/${userId}`);

    return result;
  } catch (err) {
    throw new Error(`Something went wrong: ${err.message}`);
  }
};
export const getUserSettlements = async (userId, accountId) => {
  try {
    const result = await get(
      `/api/v1/deferred-settlements/user-settlements/${userId}/${accountId}`
    );

    return result;
  } catch (err) {
    throw new Error(`Something went wrong: ${err.message}`);
  }
};
export const deleteUserOrders = async (orderId) => {
  try {
    const result = await deleteResource(`api/v1/orders/cancel/${orderId}`);

    return result;
  } catch (err) {
    throw new Error(`Something went wrong: ${err.message}`);
  }
};

export const getBanks = async () => {
  try {
    const limit = 50;
    const result = await get(`api/v1/banks/index?limit=${limit}&page=${1}`);

    return result;
  } catch (err) {
    throw new Error(`Something went wrong: ${err.message}`);
  }
};

export const getWalletAssets = async () => {
  try {
    const authId = await getAsyncData("authId");
    const result = await get("api/v1/trading-wallet/wallet-assets", { authId });

    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};
export const getFees = async (asset) => {
  try {
    const result = await get(
      `api/v1/fiat/user-withdrawal/get-fee?asset=${asset}`
    );

    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};
export const getAssets = async (type) => {
  const requestKey = `api/v1/trading-wallet/get-assets-${type || "all"}`;

  const existingPromise = pendingRequests.get(requestKey);
  if (existingPromise) {
    try {
      return await existingPromise;
    } catch (err) {
      throw err;
    }
  }

  let requestPromise;
  const promiseCreator = async () => {
    try {
      const data = await getAllTradingAssets(type);
      return {
        data: data,
        status: true,
        message: "Success",
      };
    } catch (err) {
      throw new Error(err.message);
    } finally {
      if (pendingRequests.get(requestKey) === requestPromise) {
        pendingRequests.delete(requestKey);
      }
    }
  };

  requestPromise = promiseCreator();
  pendingRequests.set(requestKey, requestPromise);

  try {
    return await requestPromise;
  } catch (err) {
    if (pendingRequests.get(requestKey) === requestPromise) {
      pendingRequests.delete(requestKey);
    }
    throw err;
  }
};
export const getAssetWallet = async (data) => {
  try {
    const result = await get("api/v1/user-wallets/get-wallet-an", data);

    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};
export const getNetwork = async (assetId) => {
  try {
    const { getAllChains } = await import("./tradingDataService");
    const allChains = await getAllChains();

    const filteredChains = allChains.filter(
      (chain) => chain.assetId === assetId
    );

    return {
      data: {
        status: true,
        data: filteredChains,
      },
    };
  } catch (err) {
    throw new Error(err.message);
  }
};
export const getNet = async (chainId) => {
  try {
    const result = await get(`api/v1/trading-assets/get-chain/${chainId}`);

    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};
export const getPortfolioEstimate = async (startDate, endDate) => {
  try {
    startDate = startDate.split("T")[0];
    endDate = endDate.split("T")[0];
    const result = await get(
      `api/v2/portfolio/performance?startDate=${startDate}&endDate=${endDate}`
    );

    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};
export const getAvailableBalances = async (balanceParams) => {
  try {
    const result = await getPortfolioEstimateAssets();

    if (result?.data?.data?.assets && balanceParams?.type) {
      const filteredAssets = result.data.data.assets.filter(
        (asset) =>
          asset.currencyType === balanceParams.type ||
          asset.type === balanceParams.type
      );
      return {
        ...result,
        data: {
          ...result.data,
          data: filteredAssets,
        },
      };
    }

    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const getTradeRate = async (assetId, tradeType, pair, isPostTrade) => {
  const normalizedPostTrade = isPostTrade === true;
  const requestKey = `api/v1/trading-wallet/get-rate-${assetId}-${tradeType}-${pair}-${normalizedPostTrade}`;

  const existingPromise = pendingRequests.get(requestKey);
  if (existingPromise) {
    try {
      return await existingPromise;
    } catch (err) {
      throw err;
    }
  }

  let promiseResolve, promiseReject;
  const placeholderPromise = new Promise((resolve, reject) => {
    promiseResolve = resolve;
    promiseReject = reject;
  });

  pendingRequests.set(requestKey, placeholderPromise);

  const promiseCreator = async () => {
    try {
      const data = {
        assetId: assetId,
        type: tradeType,
        pair: pair,
        postTrade: normalizedPostTrade,
      };
      const result = await get("api/v1/trading-wallet/get-rate", data);
      return result;
    } catch (err) {
      throw new Error(`Could not get trade rate: ${err}`);
    }
  };

  promiseCreator()
    .then((result) => {
      if (pendingRequests.get(requestKey) === placeholderPromise) {
        pendingRequests.set(requestKey, Promise.resolve(result));
      }
      promiseResolve(result);
    })
    .catch((err) => {
      if (pendingRequests.get(requestKey) === placeholderPromise) {
        pendingRequests.delete(requestKey);
      }
      promiseReject(err);
    });

  try {
    return await placeholderPromise;
  } catch (err) {
    if (pendingRequests.get(requestKey) === placeholderPromise) {
      pendingRequests.delete(requestKey);
    }
    throw err;
  }
};

export const getQuote = async (data) => {
  try {
    if (data.amount === null || data.amount === undefined) {
      throw new Error("Amount is required to generate a quote");
    }

    const amount =
      typeof data.amount === "string"
        ? parseFloat(data.amount.replace(/,/g, ""))
        : parseFloat(data.amount);

    if (isNaN(amount) || amount <= 0) {
      throw new Error("Please enter a valid amount greater than zero");
    }

    const result = await create("api/v1/trading/get-quote", data);

    if (!result) {
      throw new Error("Could not generate quote");
    }

    return result;
  } catch (err) {
    console.log(err);
    throw new Error(`${err.response.data.message}`);
  }
};

export const createAddress = async (data) => {
  try {
    const result = await update(`api/v1/pay-address/add-address?`, {}, data);
    if (!result) {
      throw new Error("Could not generate quote");
    }
    return result;
  } catch (err) {
    console.log(err);
    throw new Error(`${err.response.data.message}`);
  }
};

export const getSellQuote = async (data) => {
  try {
    const result = await create("api/v1/trading/sell-quote", data);
    if (!result) {
      throw new Error("Could not generate quote");
    }
    return result;
  } catch (err) {
    console.log(err);
    throw new Error(`${err.response.data.message}`);
  }
};

export const getEightyEightPayQuote = async (data) => {
  try {
    const result = await create("api/v1/pay/quote", data);

    if (!result) {
      throw new Error("Could not generate 80eight Pay quote");
    }

    return result;
  } catch (err) {}
};

export const createEightyEightPayTrade = async (data) => {
  try {
    const authId = await getAsyncData("userId");
    if (!authId) {
      throw new Error("authId is missing or could not be retrieved");
    }
    const requestData = {
      ...data,
      authId,
    };

    const result = await create("api/v1/pay/create", requestData);
    return result;
  } catch (err) {
    throw new Error(`Could not create 80eight Pay trade: ${err.message}`);
  }
};

export const getUserPayTransactions = async (userId) => {
  try {
    const response = await get(
      `api/v1/transaction-history/user-history/${userId}?transactionType=Payment&limit=1`
    );
    return response;
  } catch (err) {
    throw new Error(`Could not get user pay transactions: ${err.message}`);
  }
};

export const convertPortfoliioEstimate = async (asset, portfolioEstimate) => {
  try {
    const formatter = new CurrencyFormatter({
      locale: "en-ZA",
      decimalPlaces: 2,
      cryptocurrencyDecimalPlaces: 2,
      stablecoins: ["USDT", "USDC", "DAI", "XRP"],
    });
    const convertedEstimate =
      asset.type === "Crypto"
        ? portfolioEstimate / asset.sellRate
        : portfolioEstimate * asset.buyRate;

    if (isNaN(convertedEstimate) || !convertedEstimate) {
      throw new Error("Could not convert wallet value");
    }

    const formattedEstimate = formatter.format(
      convertedEstimate,
      asset.type.toLowerCase(),
      asset.asset.toUpperCase()
    );

    return formattedEstimate;
  } catch (err) {
    throw new Error(`Could not convert estimate: ${err.message}`);
  }
};

export const getTransactionHistory = async () => {
  try {
    const authId = await getAsyncData("authId");

    const response = await get("api/v1/transactions/get-history", { authId });

    return response;
  } catch (err) {
    throw new Error(`Could not get transaction history: ${err.message}`);
  }
};
export const getUserTransactionHistory = async (userId, page) => {
  try {
    const pageNum =
      page !== undefined && page !== null
        ? Math.max(1, parseInt(Number(page), 10) || 1)
        : 1;
    const response = await get(
      `api/v1/transaction-history/user-history/${userId}?page=${pageNum}`
    );

    return response;
  } catch (err) {
    throw new Error(`Could not get transaction history: ${err.message}`);
  }
};

export const getMyFiatTransactions = async (page = 1) => {
  try {
    const response = await get(
      `api/v1/fiat/my-transactions?page=${page}&limit=100`
    );
    return response;
  } catch (err) {
    throw new Error(`Could not get fiat transactions: ${err.message}`);
  }
};
export const getAddressBook = async () => {
  try {
    const response = await get("api/v1/pay-address/user-addresses");

    return response;
  } catch (err) {
    throw new Error(`Could not get transaction history: ${err.message}`);
  }
};

export const createTrade = async (data) => {
  try {
    const authId = await getAsyncData("userId");
    if (!authId) {
      throw new Error("authId is missing or could not be retrieved");
    }

    const result = await create("api/v1/trading/create-trade", data);

    return result;
  } catch (err) {
    throw new Error(`Could not create trade: ${err.message}`);
  }
};
export const createOrder = async (data) => {
  try {
    const result = await create("api/v1/orders/create-order", data);
    return result;
  } catch (err) {
    throw new Error(`Could not create order: ${err.message}`);
  }
};

export const sendCrypto = async (data) => {
  try {
    const transaction = await create(
      "/api/v1/crypto-transactions/create",
      data
    );
    return transaction;
  } catch (err) {
    throw new Error(err);
  }
};

export const getAsset = async (assetId) => {
  try {
    const result = await get(`api/v1/trading-assets`, { id: assetId });

    return result;
  } catch (err) {}
};

export const getBankTransferReference = async () => {
  try {
    const response = await get(`/api/v1/user-banking/get-reference`);
    return response;
  } catch (error) {
    throw new Error(
      `Could not fetch bank transfer reference: ${error.message}`
    );
  }
};

export const getPortfolioEstimateAssets = async () => {
  const requestKey = "api/v2/portfolio/estimate";

  if (pendingRequests.has(requestKey)) {
    try {
      return await pendingRequests.get(requestKey);
    } catch (err) {
      throw err;
    }
  }

  const requestPromise = (async () => {
    try {
      const result = await create(requestKey, {});
      pendingRequests.delete(requestKey);
      return result;
    } catch (err) {
      pendingRequests.delete(requestKey);
      throw new Error(
        `Could not get portfolio estimate assets: ${err.message}`
      );
    }
  })();

  pendingRequests.set(requestKey, requestPromise);

  try {
    return await requestPromise;
  } catch (err) {
    throw err;
  }
};

export const getMarketAssets = async () => {
  try {
    const result = await get("api/v2/market/allInfo");
    return result;
  } catch (err) {
    throw new Error(`Could not get market assets: ${err.message}`);
  }
};

export const getPriceHistory = async (symbol, interval, range) => {
  if (!symbol) return { data: { success: false, data: null } };
  try {
    const params = { interval: interval || "1d" };
    if (range) params.range = range;
    const result = await get(
      `api/v2/market/${encodeURIComponent(symbol)}/priceHistory`,
      params
    );
    return result;
  } catch (err) {
    throw new Error(`Could not get price history: ${err.message}`);
  }
};

export const refreshPortfolioAndAssets = async () => {
  try {
    await Promise.all([getPortfolioEstimateAssets(), getTradingAssets()]);
  } catch (err) {
    console.error("Error refreshing portfolio and assets:", err);
  }
};
